module.exports = __webpack_public_path__ + "img/UlrichBeitzel_140x140_rund.5909c474.jpg";